<div class="astrea-search">
    <div class="container">

        <div class="d-flex">
            <div class="my-4 mx-2">
                <div class="back-link d-flex a-i-center j-c-start mb-3">
                    <mat-icon>chevron_left</mat-icon>
                    <a [routerLink]="['/home']" title="{{ 'back' | translate }}">{{ 'back' | translate }}</a>
                </div>
                <div class="astrea-title mb-3">
                    <h1>{{ 'search.title' | translate }}</h1>
                </div>
            </div>
        </div>

        <div *ngIf="!loading; else astreaLoading" id="search_results">
            <div *ngIf="authors && authors.length > 0" class="p-2">
                <div class="d-flex j-c-between a-i-center">
                    <p class="title-results">
                        {{ 'search.title_authors' | translate }}
                    </p>
                    <a class="link-authors" routerLink="/authors" title="{{ 'pages.authors.all' | translate }}">
                        {{ 'pages.authors.all' | translate }}
                    </a>
                </div>
                <ul>
                    <li *ngFor="let a of authors" class="astrea-author-item animated astreaFade">
                        <a [routerLink]="['/author', a.authorcode]" title="{{ a.lastname | uppercase }}, {{ a.firstname }}" class="d-flex j-c-start a-i-center py-2">
                            <div class="d-flex flex-column">
                                <h2>{{ a.lastname | uppercase }}, {{ a.firstname }}</h2>
                                <p>{{ 'pages.authors.count' | translate }}: {{ a.sizeDoctrines }}</p>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
            <div *ngIf="books && books.length > 0; else withoutResults" class="d-flex j-c-start a-i-center flex-wrap">
                <p class="title-results p-2">
                    {{ 'search.title_results' | translate }}
                </p>
                <astrea-book-details
                    *ngFor="let b of books"
                    [book]="b"
                    class="animated astreaFade"
                ></astrea-book-details>
            </div>
            <ng-template #withoutResults>
                <div class="t-center">
                    <img class="img-responsive" src="/assets/images/illustrations/Illustration-library.png" alt="Estanteria con libros.">
                    <p>{{ 'search.placeholder2' | translate }}</p>
                </div>
            </ng-template>
            <div>
                <astrea-paginator
                    [itemsPerPage]="itemsPerPage"
                    [totalLength]="totalLength"
                    [pageRedirect]="'/searcher'"
                ></astrea-paginator>
            </div>
        </div>

        <ng-template #astreaLoading>
            <astrea-loading
                text="Buscando obras"
            ></astrea-loading>
        </ng-template>

    </div>
</div>
